import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _sources;

export var sourceKeys;

(function (sourceKeys) {
  sourceKeys["GENERAL"] = "GENERAL";
  sourceKeys["UPGRADE_BUTTON"] = "UPGRADE_BUTTON";
  sourceKeys["USAGE_LIMIT"] = "USAGE_LIMIT";
  sourceKeys["LIMIT_PACK"] = "LIMIT_PACK";
  sourceKeys["FEATURE_LIMIT"] = "FEATURE_LIMIT";
  sourceKeys["CHECKOUT"] = "CHECKOUT";
  sourceKeys["CONTACT_SALES"] = "CONTACT_SALES";
  sourceKeys["CONTACT_SALES_BUTTON"] = "CONTACT_SALES_BUTTON";
  sourceKeys["TRIAL"] = "TRIAL";
  sourceKeys["TRIAL_BUTTON"] = "TRIAL_BUTTON";
  sourceKeys["EXPIRED_TRIAL_MODAL"] = "EXPIRED_TRIAL_MODAL";
  sourceKeys["TRIAL_MODAL"] = "TRIAL_MODAL";
  sourceKeys["LOCKED_FEATURE"] = "LOCKED_FEATURE";
  sourceKeys["LOCKED_APP"] = "LOCKED_APP";
  sourceKeys["UPGRADE_BANNER"] = "UPGRADE_BANNER";
  sourceKeys["PRODUCT_ACTIVATION"] = "PRODUCT_ACTIVATION";
  sourceKeys["STANDALONE"] = "STANDALONE";
})(sourceKeys || (sourceKeys = {}));

export var sources = (_sources = {}, _defineProperty(_sources, sourceKeys.GENERAL, 'general'), _defineProperty(_sources, sourceKeys.UPGRADE_BUTTON, 'upgrade-button'), _defineProperty(_sources, sourceKeys.USAGE_LIMIT, 'usage-limit'), _defineProperty(_sources, sourceKeys.LIMIT_PACK, 'limit-pack'), _defineProperty(_sources, sourceKeys.FEATURE_LIMIT, 'feature-limit'), _defineProperty(_sources, sourceKeys.CHECKOUT, 'checkout'), _defineProperty(_sources, sourceKeys.CONTACT_SALES, 'contact-sales'), _defineProperty(_sources, sourceKeys.CONTACT_SALES_BUTTON, 'contact-sales-button'), _defineProperty(_sources, sourceKeys.TRIAL, 'trial'), _defineProperty(_sources, sourceKeys.TRIAL_BUTTON, 'trial-button'), _defineProperty(_sources, sourceKeys.EXPIRED_TRIAL_MODAL, 'expired-trial-modal'), _defineProperty(_sources, sourceKeys.TRIAL_MODAL, 'trial-modal'), _defineProperty(_sources, sourceKeys.LOCKED_FEATURE, 'locked-feature'), _defineProperty(_sources, sourceKeys.LOCKED_APP, 'locked-app'), _defineProperty(_sources, sourceKeys.UPGRADE_BANNER, 'upgrade-banner'), _defineProperty(_sources, sourceKeys.PRODUCT_ACTIVATION, 'product-activation'), _defineProperty(_sources, sourceKeys.STANDALONE, 'standalone'), _sources);